import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// Components
import { Route, Switch, withRouter } from "react-router-dom";
// import { withRouter } from "react-router";
import { Tab, Row, Col, Container } from "react-bootstrap";
import NotFound from "../layout/NotFound";
import GeneralSettings from "../GeneralSettings";
import ManageUsers from "../ManageUsers";
import SelectBusiness from "../SelectBusiness";
import MenuLink from "../MenuLink";
import ManageMenus from "../ManageMenus";
import SideNavBar from "../layout/SideNavBar";
import Logout from "../Logout";
const Routes = ({ auth: { userGroup }, history }) => {
  useEffect(() => {
    /**
     * Redirect to "/restaurant-setting" if user select "userGroup"
     */
    if (userGroup) {
      history.push("/restaurant-setting");
    }
  }, [userGroup, history]);

  return (
    <>
      <Container fluid className="settings-container">
        <Tab.Container id="left-tabs-example" defaultActiveKey="createMenu">
          <Row className={userGroup ? "settings-content" : ""}>
            {userGroup && (
              <Col xs={12} lg={4} xl={3} className="mb-5">
                <SideNavBar />
              </Col>
            )}
            <Switch>
              <Route>
                <Route exact path="/">
                  <Col md={{ span: 6, offset: 3 }}>
                    <SelectBusiness />
                  </Col>
                </Route>
                <Col xs={12} lg={8}>
                  <Route
                    exact
                    path="/restaurant-setting"
                    component={GeneralSettings}
                  />
                  <Route exact path="/menus-list" component={ManageMenus} />
                  <Route exact path="/users" component={ManageUsers} />
                  <Route
                    exact
                    path={["/qr-code", "/qr-code/:menuPath"]}
                    component={MenuLink}
                  />
                  <Route exact path="/logout" component={Logout} />
                </Col>
              </Route>
              <Col xs={12} xl={1} className="d-lg-none" />
              <Route component={NotFound} />
            </Switch>
          </Row>
        </Tab.Container>
      </Container>
    </>
  );
};

Routes.propTypes = {
  auth: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default withRouter(connect(mapStateToProps)(Routes));
